import { Tooltip } from '../../core/slots/Tooltip.js';
import { DISPLAY_NAME } from '../constants/defaults.js';
import { XYChartTooltipProps } from '../types/xy-chart-props.js';

export const XYChartTooltipSlot = Tooltip<XYChartTooltipProps>(DISPLAY_NAME);
